<template class="global-search">
  <v-autocomplete
    v-model="select"
    :menu-props="{
      closeOnContentClick:true,
      rounded: 'xxl',
      maxHeight: '500',
      nudgeBottom: 8 + 'px',
      contentClass: 'global-custom-autocomplete'
    }"
    deletable-chips
    clearable
    underlined
    :loading="isLoading ? 'var(--v-accent-base)' : false"
    no-filter
    :search-input.sync="searchKeyword"
    :disabled="isUpdating"
    :items="entries" 
    item-text="title"
    item-value="id" 
    :placeholder="$t('globalSearchPlaceholder')"
    :hide-no-data="isLoading || keyword == null"
    :no-data-text="$t('globalSearchNoResults')"
    append-icon=""
    hide-details
    data-testid="search-dashboard"
    class="global-search"
    @blur="closeSearch"
  >
  <template v-slot:prepend-inner>
    <v-icon
      class="v-list-item__icon ma-0 pa-0 text-h4"
      >
      mdi-magnify
    </v-icon>
  </template>
  <template v-slot:selection="" />
  <template
    v-slot:item="data"
    data-testid="suggested-item"
    class="rounded-xl mt-4"
  >
    <template v-if="((typeof data.item) !== 'object') && !this.isLoading">
      <v-list-item-content v-text="data.item" />
    </template>
    <template v-else>
      <v-row
          class="py-2 mx-1 rounded-xl global-search--item overflow-hidden"
          :class="!mobile() ? 'my-3' : 'my-2'"
          @click="
            data.item.type == 'activities' ? showActivityDetail(data.item.uuid)
            : data.item.type == 'hubs' ? showHubDetail(data.item.uuid)
            : data.item.type == 'workflows' ? showWorkflowDetail(data.item.uuid)
            : data.item.type == 'checkitems' ? showCheckitemDetail(data.item.activity_id, data.item.checklist_id)
            : data.item.type == 'checklists'
            || data.item.type == 'activity-pages'
            || data.item.type == 'quizzes'
            || data.item.type == 'scorms'
            || data.item.type == 'surveys' ? showActivityFeedItemDetail(data.item.type, data.item.activity_id, data.item.uuid)
            : showSectionDetail(data.item.activity_id)"
          align="center"
        >
          <v-col
            v-if="data.item.type == 'activities' || data.item.type == 'hubs'"
            cols="3"
            lg="3"
            md="2"
            sm="2"
            class="my-0 ml-1 pa-0"
          >
            <v-img
              :src="(data.item.image) ? data.item.image : data.item.type == 'activities' ? require('../assets/cover-activity.jpg') : data.item.type == 'hubs' ? require('../assets/background-hub.jpg') : ''"
              class="ma-0 mx-2 rounded-lg"
              :class="data.item.type == 'activities'? 'activity' : 'hub'" :width="!mobile() ? '120px' : '70px'" :height="!mobile() ? '64px' : '45px'"
            />
          </v-col>
          <v-col
            v-else-if="data.item.type == 'workflows'"
            cols="3"
            lg="3"
            md="2"
            sm="2"
            class="my-0 ml-1 pa-0 d-flex align-center justify-center"
          >
            <v-icon small>mdi-sitemap</v-icon>
          </v-col>
          <v-col
            v-else
            cols="1"
            class="my-0 ml-6 pa-0"
            :class="mobile() ? 'mr-7' : ''"
          >
            <v-icon
              v-if="data.item.type == 'activity-pages'"
              class="v-list-item__icon ma-0 pa-2 rounded-lg global-search-icon--page"
            >
              mdi-text
            </v-icon>
            <v-icon
              v-if="data.item.type == 'checklists' || data.item.type == 'checkitems'"
              class="v-list-item__icon ma-0 pa-2 rounded-lg global-search-icon--checklist"
              >
              mdi-order-bool-ascending-variant
            </v-icon>
            <v-icon
            v-if="data.item.type == 'surveys'"
              class="v-list-item__icon ma-0 pa-2 rounded-lg global-search-icon--survey"
              >
              mdi-help-box-multiple-outline
            </v-icon>
            <v-icon
              v-if="data.item.type == 'quizzes'"
              class="v-list-item__icon ma-0 pa-2 rounded-lg global-search-icon--quiz"
            >
              mdi-chat-question-outline
            </v-icon>
            <v-icon
              v-if="data.item.type == 'scorms'"
              class="v-list-item__icon ma-0 pa-2 rounded-lg global-search-icon--scorm"
            >
              mdi-text
            </v-icon>
            <v-icon
            v-if="data.item.type == 'sections'"
            class="v-list-item__icon ma-0 pa-2 rounded-lg global-search-icon--section"
            >
              mdi-chevron-down
            </v-icon>
          </v-col>
          <v-col
            cols="8"
            class="my-0 py-0 align-self-baseline pr-0"
          >
              <v-row>
                  <v-col cols="8" class="px-5 pt-1 pb-1 global-search--type">
                      TYPE: {{ data.item.type == 'activities' ? 'ACTIVITY' : data.item.type == 'workflows' ? 'PROGRAM' : data.item.type == 'hubs' ? 'HUB' : data.item.type == 'activity-pages' ? 'PAGE' : data.item.type == 'surveys' ? 'SURVEY' : data.item.type == 'checklists' ? 'CHECKLIST' : data.item.type == 'checkitems' ? 'CHECKITEM' : data.item.type == 'quizzes' ? 'QUIZ' : data.item.type == 'sections' ? 'SECTION' : 'SCORM' }}
                  </v-col>
              </v-row>
              <v-list-item-content class="pt-0 pb-1 font-weight-bold global-search--title">
                  <v-list-item-title
                      class="text-no-wrap text-truncate px-2"
                      v-html="highlighted(data.item.title, searchKeyword)"
                  >
                  </v-list-item-title>
              </v-list-item-content>
              <v-list-item-content v-if="data.item.type !== 'workflows'&& (data.item.description || data.item.content)" class="pt-0 pb-1 font-weight-bold">
                  <v-list-item-subtitle
                      class="text-no-wrap text-truncate px-2 font-weight-light font-italic global-search--content"
                      v-html="highlighted((data.item.description || data.item.content), searchKeyword)"
                  >
                  </v-list-item-subtitle>
              </v-list-item-content>
          </v-col>
        </v-row>
    </template>
  </template>
  </v-autocomplete>
</template>
<script>
import i18n from '../plugins/i18n'
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import { searchGlobal } from '../api/spaceApi'
import _ from 'lodash'
export default {
  mixins: [repeatedMethodsMixin],
  props: {
    spaceId: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return { 
      searchClosed:true,
      select: null,
      searchKeyword:null,
      keyword:null,
      isUpdating: false,
      entries:[], 
      isLoading:false   
    }
  },
  filters: {
    highlight: function (value, string) {
      return value.replace(string, '<span class=\'highlight\'>' + string + '</span>')
    }
  },  
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    }
  },
  watch: {
    searchKeyword: _.debounce(
    function () {
      this.keyword = this.searchKeyword
      this.entries = []
      if (this.searchKeyword == null || this.searchKeyword == '') return
      this.isLoading = true
      let searchkey = this.searchKeyword.trim()
      if (searchkey.length < 1) return
      this.globalSearch(searchkey)
    }, 1000),  
  },
  methods: {
    closeSearch(){
      this.search = null
      this.searchKeyword = null
      this.keyword = null
      this.$nextTick(() => {
        this.searchClosed = true
      })
      this.entries = []
    },
    showActivityDetail(id){
      this.$router.push({path: '/activity/' + id })
    },
    showHubDetail(id){
      this.$router.push({path: '/hub/' + id })
    },
    showWorkflowDetail(id){
      this.$router.push({path: '/workflow/' + id })
    },
    showActivityFeedItemDetail(type, activityId, id){
      switch (type) {
        case 'activity-pages':
          this.$router.push({path: '/activity/' + activityId + '/page/' + id })
          break
        case 'checklists':
          this.$router.push({path: '/activity/' + activityId + '/checklist/' + id })
          break
        case 'quizzes':
          this.$router.push({path: '/activity/' + activityId + '/quiz/' + id })
          break
        case 'surveys':
          this.$router.push({path: '/activity/' + activityId + '/survey/' + id })
          break
        case 'scorms':
          this.$router.push({path: '/activity/' + activityId + '/scorm/' + id })
          break
      }
    },
    showCheckitemDetail(activityId, id){
      this.$router.push({path: '/activity/' + activityId + '/checklist/' + id })
    },
    showSectionDetail(activityId){
      this.$router.push({path: '/activity/' + activityId})
    },
    async globalSearch(keyword){
      let searchPrograms = []
      let searchActivities = []
      let searchHubs = []
      let searchPages = []
      let searchSurveys = []
      let searchChecklists = []
      let searchCheckitems = []
      let searchQuizzes = []
      let searchSections = []
      let searchScorms = []
      if(keyword && keyword.trim().length >= 1){
        this.isLoading = true
        try {
            const response = await searchGlobal(this.spaceId, keyword)
            if(response){
              if(response.status == 200){
                searchPrograms = response.data.meta.workflows
                searchActivities = response.data.meta.activities
                searchHubs = response.data.meta.hubs
                searchPages = response.data.meta.activity_pages
                searchSurveys = response.data.meta.surveys
                searchChecklists = response.data.meta.checklists
                searchCheckitems = response.data.meta.checkitems
                searchQuizzes = response.data.meta.quizzes
                searchSections = response.data.meta.sections
                searchScorms = response.data.meta.scorms
              }
            }
        } catch (e) {
            if(e.response){
              this.error = true
              this.alertType = 'error'
              this.alertMsg =  i18n.t('serverError')
              this.alertValue = true
            } 
        }
        this.entries = [].concat(searchActivities,searchHubs,searchPages,searchSurveys,searchChecklists,searchCheckitems,searchQuizzes,searchSections,searchScorms, searchPrograms)
        this.entries = this.entries.filter(Boolean) 
        this.isLoading = false
      }
      this.isLoading = false
    },
    highlighted(value, string) {
      let pos = value.indexOf(string)
      if (pos >= 50) {
        value = '...' + value.slice(pos-15)
      }
      
      var invalid = /[°"§%()\]{}=\\?´`'#<>|,;.:+_-]+/g;
      string = string.replace(invalid, "");
      let regex  = new RegExp(string, "gi");
      return value.replace(regex , '<span class=\'global-search-highlight\'>$&</span>')
    }
  },
}
</script>
<style>
  .global-search:active .global-search:focus {
    outline: none;
  }
  .global-search.v-text-field.v-input--is-focused .v-input__slot {
    border: 0 !important;
  }
  .global-search-icon--page.v-icon {
    background-color:#F7BAD8; 
    color:#EF5DA5
  }
  .global-search-icon--checklist.v-icon {
    background-color:#B3C3E1; 
    color:#688BC6
  }
  .global-search-icon--quiz.v-icon {
    background-color:#FBEBB2; 
    color:#FCD458
  }
  .global-search-icon--survey.v-icon {
    background-color:#C5F2E9; 
    color:#51DAC1
  }
  .global-search-icon--scorm.v-icon {
    background-color:#C9E3F2; 
    color:#67B5E1
  }
  .global-search-icon--section.v-icon {
    background-color:#FBB3AE; 
    color:#FC7B73
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover .global-search-icon--page.v-list-item__icon {
    color: #EF5DA5 !important;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover .global-search-icon--checklist.v-list-item__icon {
    color: #688BC6 !important;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover .global-search-icon--quiz.v-list-item__icon {
    color: #FCD458 !important;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover .global-search-icon--survey.v-list-item__icon {
    color: #51DAC1 !important;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover .global-search-icon--scorm.v-list-item__icon {
    color: #67B5E1 !important;
  }
  .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover .global-search-icon--section.v-list-item__icon {
    color: #FC7B73 !important;
  }
  .global-search .v-input__icon--prepend-inner i{
    font-size: 30px !important;
  }
  .global-search--item {
    background-color: var(--v-primary-lighten3) !important;
  }
  .global-search--type {
    font-size: 10px !important;
    font-weight: 500 !important;
  }
  .global-search--title {
    font-size: 20px;
    width: 280px;
  }
  .global-search--content {
    font-size: 11px;
    width: 280px;
  }
  .global-custom-autocomplete.v-autocomplete__content.v-menu__content {
    z-index: 0 !important;
  }
</style>